<template>
  <div style="width:80%;margin:0 auto">
    <a-card title="合作伙伴 - 太仓远太国际船舶代理有限公司" :bordered="false" :headStyle="{ 'font-weight': 'bold','font-size': '24px' }" style="margin-top:24px;">
      <a-row type="flex" justify="center">
        <a-col :span="24" style="text-align:left;text-indent:3em;margin-top:24px;">
          <p>
            太仓远太国际船舶代理有限公司是由上海远东环球国际船舶代理有限公司和太仓港国际货运有限公司共同投资组建，经国家交通部批准的国际船舶代理企业。公司注册资金150万元。
          </p> 
          <br />
          <p>
            公司主要经营范围为：中外籍国际船舶代理业务、散杂货、集装箱的揽货、订舱、报关、租船及多式联运、代签提单、处理海商、海事等事宜。公司以太仓港本港为依托，代理太仓至台湾班轮航线及外贸内支线班轮，通过不断提升服务质量来满足不同客户的物流需求。
          </p>  
          <br />
          <p>
            公司坚持“诚信、优质、高效、创新”的企业精神，竭诚为国内外客户提供一流的服务。
          </p> 
          <br />
          <br />
          <p>
            公司地址：太仓市郑和路309号 太仓发展大厦9楼
          </p> 
          <p>
            联系电话：0512-53569699
          </p> 
          <p>
            传真：0512-53569728
          </p> 
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>

export default {
  name: 'tcsbggs',
}
</script>

<style scoped>
p {
  font-size: 20px;
}
</style>
